import React, { useEffect, useState } from "react";
import HeaderOS1 from "./HeaderOS1";
import "./FormularioStyle.css"
import { useNavigate, useSearchParams } from "react-router-dom";
import ServiceBackend from "../Services/ServiceBackend"
import configSecc from "../Services/config.json";
import CanvasDraw from "react-canvas-draw";
import { useRef } from "react";
import ModalStyles from "./ModalStyles.module.css";
import { Modal, ModalBody, ModalHeader, Label, ModalFooter, Button, Spinner} from "reactstrap";
import ModalFirmaData from "./Common/ModalFirmaData";
import ModalFirmaPie from "./Common/ModalFirmaPie";


const FormularioOS1 = () => {

    const [loading, setLoading] = useState(false)
    const [modalFirmaOS, setModalFirmaOS] = useState(false);
    const [modalFirmaSIN, setModalFirmaSIN] = useState(false);
    const navigate = useNavigate();
    const [cct12390, setCct12390] = useState(false); 
    const [cct50107, setCct50107] = useState(false);

    const [dia, setDia] = useState(0);
    const [mes, setMes] = useState(0);
    const [anio, setAnio] = useState(0);
    const [delegacion, setDelegacion] = useState(0)
    const [datos, setDatos] = useState({});
    const [tipoForm, setTipoForm] = useState("");

    const [searchParams, setSearchParams] = useSearchParams();
    const [fileRecibo, setFileRecibo] = useState();
    const [fileAlta, setFileAlta] = useState();
    const [fileDNI, setFileDNI] = useState();
    const [fileDNI2, setFileDNI2] = useState();

    const firmaOS = useRef(null);
    const firmaSIN = useRef(null);
    const [firmaStringOS, setFirmaStringOS] = useState("");
    const [firmaStringSIN, setFirmaStringSIN] = useState("");
    const [firmaBase64SIN, setFirmaBase64SIN] = useState("")
    const [firmaBase64OS, setFirmaBase64OS] = useState("");

    const [errors, setErrors] = useState([]);
    const [valid, setValid] = useState(false);

    const toggleModalFirmaOS = () =>{ setModalFirmaOS(!modalFirmaOS)}
    const toggleModalFirmaSIN = () => { setModalFirmaSIN(!modalFirmaSIN)}
    const origen = searchParams.get("origen");
    const fileAccept = origen === "APP" ? ".jpg,.jpeg,.png,.pdf" : "image/*,application/pdf";
    //const origin_image=  origen === "APP" ? false;


    const resetFields = () => {
        setDatos({
            ...datos,
            tipo: tipoForm,
            seccional: 1,
            nrotramite: randomIntFromInterval(10000000, 99999999),
            provincia: "Buenos Aires",
            provincialaboral: "Buenos Aires",
            sexo: "M",
            estcivil: "Soltero",
            nombreapellido : "",
            domicilio : "",
            cp: "",
            localidad : "",
            email : "",
            fechanac : "",
            tel: "",
            cel: "",
            edad: "",
            nacionalidad: "",
            cuil: "",
            cuit: "",
            fechaalta: "",
            razonsocial: "",
            categorialaboral: "",
            direccionlaboral: "",
            localidadlaboral: "",
            telefonolaboral: "",
            emaillaboral: "",
            paginaweblaboral: "",
            f1apellidonombre: null,
            f1cuil: null,
            f1parentesco: null,
            f1fecnac: null,
            f2apellidonombre: null,
            f2cuil: null,
            f2parentesco: null,
            f2fecnac: null,
            f3apellidonombre: null,
            f3cuil: null,
            f3parentesco: null,
            f3fecnac: null,
            f4apellidonombre:null,
            f4cuil:null,
            f4parentesco: null,
            f4fecnac: null,
            f5apellidonombre: null,
            f5cuil: null,
            f5parentesco: null,
            f5fecnac: null,
            observaciones: null
        });
        setFileRecibo("");
        setFileAlta("");
        setFileDNI("");
        setFileDNI2("");
    }

    const fillFields = () => {
       
       if (datos.tipo=="" || datos.tipo=="undefined" || datos.tipo!=tipoForm)
       setCct12390(true);
    setCct50107(false);
       setDatos({
        ...datos,
        seccional: 1,
        nrotramite: randomIntFromInterval(10000000, 99999999),
        provincia: "Buenos Aires",
        provincialaboral: "Buenos Aires",
        sexo: "M",
        estcivil: "Soltero",
        tipo: tipoForm,
        
    })

    }

    const setCurrent = () =>{
        const now = new Date();
        setDia(now.getDate());
        setMes(now.getMonth()+1);
        setAnio(now.getFullYear());
    }
    

    const setCct12390Checked =() => {
        setCct12390(!cct12390)
    }

    const setCct50107Checked =() => {
        setCct50107(!cct50107)
    }
    const setTipoFormulario =() =>{
        let valUrl = searchParams.get("tipo");
        if (valUrl=="OS"){
            setTipoForm("OS")
            setDatos({
                ...datos,
                cct12390:true
                ,cct50107:false});
        }
        else if (valUrl=="SIN"){
            setTipoForm("SIN")
            setDatos({
                ...datos,
                cct12390:true
                ,cct50107:false});}
        else {setTipoForm("OSSIN");
        setDatos({
            ...datos,
            cct12390:true
            ,cct50107:false})}

            
    }

    const changeHandler = (e) =>{
        const { name, value } = e.target;
        setDatos({
          ...datos,
          [name]: value,
        });
      };

const handleFileUploadRecibo = (e) => {
            setFileRecibo(e.target.files[0]);
    }

const handleFileUploadAlta = (e) => {
        setFileAlta(e.target.files[0]);
}

const handleFileUploadDNI1 = (e) => {
    setFileDNI(e.target.files[0]);
}

const handleFileUploadDNI2 = (e) => {
    setFileDNI2(e.target.files[0]);
}




const handleSubmit = () =>{

    if (validateForm()) {
        setLoading(true)  

    var firmaOSStr = (tipoForm=="OS" || tipoForm=="OSSIN")?firmaStringOS:"";
    var firmaSINStr = (tipoForm=="SIN" || tipoForm=="OSSIN")?firmaStringSIN:"";
    //var firmaOSStr = (tipoForm=="OS" || tipoForm=="OSSIN")? firmaOS.current.getSaveData(): "";
    //var firmaSINStr = (tipoForm=="SIN" || tipoForm == "OSSIN") ? firmaSIN.current.getSaveData() : "";    
    ServiceBackend.doThePost(datos,fileRecibo,fileAlta, fileDNI, fileDNI2, firmaOSStr, firmaSINStr , tipoForm, firmaBase64OS, firmaBase64SIN)
    .then((resp)=> { 
        setLoading(false)
        console.log(resp)
        //alert("Se ha registrado correctamente, se le enviará un correo con la documentación");
        //resetFields();
        if (origen === "APP")
            window.location=("https://main.d16xmm9wnp0zua.amplifyapp.com/#/dashboard");
        else
            navigate("/done")
    })
    .catch((er)=> {
        console.log(er);
        setLoading(false)
        if (er!=null && er.response!=null && er.response.data!=null && er.response.data.message!=null)
        alert(er.response.data.message);
    else
        alert("Servicio no disponible, intente más tarde");
    })
    ; }
}



const validateFirmaOSField = ( errorList) => {
        if (firmaStringOS=="" || firmaStringOS==undefined){
        errorList.push("firmaOS");
        setValid(false);
    }
}

const validateFirmaSINField = (errorList) => {
    if (firmaStringSIN=="" || firmaStringSIN==undefined){
    errorList.push("firmaSIN");
    setValid(false);
}
}
 
const validateField = (f, fname, errorList) => {
    if (f=="" || f==undefined)
       errorList.push(fname);
        setValid(false);
}

const getErrorMessageField = (fieldname) => {
    if (errors.includes(fieldname))
        return "Debe completar este campo"; 
    else
        return "";
} 

const getErrorMessageFieldSize = (fieldname) => {
    if (errors.includes(fieldname))
        return "El tamaño del archivo debe ser menor a 10MB"; 
    else
        return "";
} 

const getErrorFirmaMessageField = (fieldname) => {
    if (errors.includes(fieldname))
        return "Deberá firmar aquí"; 
    else
        return "";
} 


function randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

const validateFileSize = (f, fileFieldName, errorList) => {
    if (f!=null && f.size>10000000) {
    errorList.push(fileFieldName)
    setValid(false)
}
}

const validateForm = () => {
    setValid(true);
    var errorList= new Array();
    
    validateField(datos.seccional, "seccional", errorList)
    validateField(datos.nrotramite, "nrotramite", errorList);
    validateField(datos.nombreapellido, "nombreapellido", errorList);
    validateField(datos.domicilio, "domicilio",errorList);
    validateField(datos.cp, "cp", errorList);
    validateField(datos.localidad, "localidad", errorList);
    validateField(datos.provincia, "provincia", errorList);
    validateField(datos.email, "email", errorList);
    validateField(datos.tel, "tel", errorList);
    validateField(datos.cuit, "cuit", errorList);

    validateField(datos.fechanac, "fechanac", errorList);
    validateField(datos.edad, "edad", errorList);
    validateField(datos.sexo, "sexo", errorList);
    validateField(datos.nacionalidad, "nacionalidad", errorList);
    validateField(datos.cuil, "cuil", errorList);
    validateField(datos.estcivil, "estcivil", errorList);
    validateField(datos.cel, "cel", errorList);
    validateField(datos.fechaalta, "fechaalta", errorList);
    validateField(datos.razonsocial, "razonsocial", errorList);
    validateField(datos.categorialaboral, "categorialaboral", errorList);
    validateField(datos.direccionlaboral, "direccionlaboral", errorList);
    validateField(datos.localidadlaboral, "localidadlaboral", errorList);
    validateField(datos.provincialaboral, "provincialaboral", errorList);
    validateField(datos.emaillaboral, "emaillaboral", errorList);
    validateField(datos.telefonolaboral, "telefonolaboral", errorList);
    validateField(fileRecibo, "fileRecibo", errorList);
    validateField(fileAlta, "fileAlta", errorList);
    validateField(fileDNI, "fileDNI", errorList);
    validateField(fileDNI2, "fileDNI2", errorList);
    validateFileSize(fileRecibo, "fileReciboSize", errorList);
    validateFileSize(fileAlta, "fileAltaSize", errorList);
    validateFileSize(fileDNI, "fileDNISize", errorList);
    validateFileSize(fileDNI2, "fileDNI2Size", errorList);
    if (tipoForm=="OS" || tipoForm == "OSSIN"){
        validateFirmaOSField(errorList);
    }
    if (tipoForm=="SIN" || tipoForm == "OSSIN"){
        validateFirmaSINField(errorList);
    
    }
    setErrors(errorList);

    console.log(errorList)
    
    return errorList.length==0;


}

  const changeTipoFormulario = (e) => {
    setTipoForm(e.target.value);
    
       setCct12390(true);
       setCct50107(false);
  
}


    useEffect(()=>{
setCurrent();
setTipoFormulario();

fillFields();


    },[])

    
    const confirmFirmaOS = () => {
        var firmaText = firmaOS.current.getSaveData();
        var firmaBase64 = firmaOS.current.canvasContainer.childNodes[1].toDataURL();

         var dataFirma = JSON.parse(firmaText);
        if (dataFirma.lines.length>0) {
            setFirmaStringOS(firmaText);
            setFirmaBase64OS(firmaBase64);
            toggleModalFirmaOS();
        }
        else alert("Debe firmar para poder continuar")
        
    }

    const resetFirmaOS = () => {
        firmaOS.current.clear();
    }

    const resetFirmaSIN = () => {
        firmaSIN.current.clear();
    }


    const confirmFirmaSIN = () => {
        var firmaText = firmaSIN.current.getSaveData();
        var firmaBase64 = firmaSIN.current.canvasContainer.childNodes[1].toDataURL();
         var dataFirma = JSON.parse(firmaText);
        if (dataFirma.lines.length>0) {
            setFirmaStringSIN(firmaText);
            setFirmaBase64SIN(firmaBase64);
            toggleModalFirmaSIN();
            
        }
        else alert("Debe firmar para poder continuar")
    }

    return(
        <>
        <Modal isOpen={modalFirmaOS} toggle={toggleModalFirmaOS} modalClassName={ModalStyles.modalposOS} contentClassName={ModalStyles.modalInfo}>
            <ModalBody className={ModalStyles.modalInfo}>
                <h4> Firma Alta Obra Social</h4>
                    <ModalFirmaData datos={datos}/>
                <h5 style={{marginTop:"20px"}}>Firma Conforme</h5>
                <div className="row">
                    <div className="col-sm-8">
            <CanvasDraw brushRadius={1} lazyRadius={0} canvasWidth={330} canvasHeight={150} style={{border:"1px solid black"}} ref={firmaOS}/>
                    </div>
                </div>
                <ModalFirmaPie confirmFirma={confirmFirmaOS} resetFirma={resetFirmaOS} toggleModal={toggleModalFirmaOS}/>
          </ModalBody>
        </Modal>

        <Modal isOpen={modalFirmaSIN} toggle={toggleModalFirmaSIN} modalClassName={ModalStyles.modalposOS} contentClassName={ModalStyles.modalInfo}>
            <ModalBody className={ModalStyles.modalInfo}>
                <h4> Firma Alta Sindicato</h4>
                    <ModalFirmaData datos={datos}/>
                <h5 style={{marginTop:"20px"}} >Firma Conforme</h5>
                <div className="row">
                    <div className="col-sm-8">
            <CanvasDraw brushRadius={1} lazyRadius={0} canvasWidth={330} canvasHeight={150} style={{border:"1px solid black"}} ref={firmaSIN}/>
                    </div>
                </div>
                <ModalFirmaPie confirmFirma={confirmFirmaSIN} resetFirma={resetFirmaSIN} toggleModal={toggleModalFirmaSIN}/>
          </ModalBody>
        </Modal>
        
       <div className="container-fluid margin20 needs-validation">
       <HeaderOS1 tipo={tipoForm}/>
       <h1 className="bd-content-title">
            Solicitud de afiliación 
        </h1>
       <div className="row"><div className="col-sm-4 from-group">&nbsp;</div>
<div class="col-sm-4 form-group">
        <label class="control-label" onClick={toggleModalFirmaOS}> Tipo de formulario</label>
        <select class="form-control" name="tipoFormulario" value = {tipoForm} onChange={changeTipoFormulario} >
            <option value="OS">Obra Social</option>
            <option value="SIN">Sindicato</option>
            <option value="OSSIN">Obra social - Sindicato</option>
        </select>
</div><div className="col-sm-4 from-group">&nbsp;</div>
<div className="row"><div className="col-1-sm">&nbsp;</div></div>
</div>

       
    

    <div className="row">

    <div className="col-sm-4 smallLabel">
    <input checked={cct12390} name="cct12390" type="checkbox" onChange={setCct12390Checked} />&nbsp;&nbsp;CCT 808/24 Textil
    </div>
    </div><div className="row">
    <div className="col-sm-4 smallLabel">  
    <input checked={cct50107} name="cct50107" type="checkbox" onChange={setCct50107Checked} />&nbsp;&nbsp;CCT 501/07 Indumentaria
    </div>

        <div className="col-sm-4 alignRight letraFecha">  
        Fecha: {dia}
         / {mes} / {anio}
    </div>
    </div>
    <div className="row">
        <div className="col-sm-6 form-group">
            <label  for="validationDefault01className" className="control-label">Seccional/Delegación: </label>
           
        <select class="form-control" name="seccional" value = {datos.seccional} onChange={changeHandler} >
            {
                configSecc.seccionales.map(sec=>{return <option value={sec.id}>{sec.nombre}</option>})
            }
            
        </select>
            
          
                <div className="formError">{getErrorMessageField("seccional")}</div>
                
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label"> Nº trámite: </label>
            <input type="number" className="form-control" placeholder="" id="nrotramite"
                name="nrotramite" maxLength="20" value={datos.nrotramite} onChange={changeHandler} readOnly="true"/>
                <div className="formError">{getErrorMessageField("nrotramite")}</div>
            </div>
    </div>
    <div className="row">
        <div className="col-sm-10 form-group">
            <label className="control-label">Apellido y nombre: </label>
            <input type="text" className="form-control" placeholder="" id="nombreapellido"
                name="nombreapellido" maxLength="50" value={datos.nombreapellido} onChange={changeHandler}/>
                 <div className="formError">{getErrorMessageField("nombreapellido")}</div>
        </div>
    </div>
    <div className="row">
        <div className="col-sm-5 form-group">
            <label className="control-label">Domicilio: </label>
            <input type="text" className="form-control" placeholder="" id="domicilio"
                name="domicilio" maxLength="50" value={datos.domicilio} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("domicilio")}</div>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">CP: </label>
            <input type="number" className="form-control" placeholder="" id="cp"
                name="cp" maxLength="4" value={datos.cp} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("cp")}</div>
            </div>
            <div className="col-sm-4 form-group">
            <label className="control-label">Localidad: </label>
            <input type="text" className="form-control" placeholder="" id="localidad"
                name="localidad" maxLength="30" value={datos.localidad} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("localidad")}</div>
            </div>
    </div>
    <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Provincia: </label>
            <select class="form-control" name="provincia" value = {datos.provincia} onChange={changeHandler} >
            {
                configSecc.provincias.map(sec=>{return <option value={sec.nombre}>{sec.nombre}</option>})
            }
            
        </select>
          
        </div>
        <div className="col-sm-4 form-group">
            <label className="control-label">Email: </label>
            <input type="text" className="form-control" placeholder="" id="email"
                name="email" maxLength="50" onChange={changeHandler} value={datos.email}/>
                <div className="formError">{getErrorMessageField("email")}</div>
            </div>
            <div className="col-sm-4 form-group">
            <label className="control-label">Tel: </label>
            <input type="text" className="form-control" placeholder="" id="tel"
                name="tel" maxLength="20" value={datos.tel} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("tel")}</div>
            </div>
    </div>
    <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Fecha Nac. </label>
            <input type="date" className="form-control" placeholder="" id="fechanac"
                name="fechanac" maxLength="50" value={datos.fechanac} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("fechanac")}</div>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Edad: </label>
            <input type="number" className="form-control" placeholder="" id="edad"
                name="edad" maxLength="2" value={datos.edad} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("edad")}</div>
            </div>
            <div className="col-sm-2 form-group">
            <label className="control-label">Sexo: </label>

            <select class="form-control" name="sexo" value = {datos.sexo} onChange={changeHandler} >
            {
                configSecc.sexo.map(sec=>{return <option value={sec.nombre}>{sec.nombre}</option>})
            }
            
        </select>
            
            </div>
            <div className="col-sm-4 form-group">
            <label className="control-label">Nacionalidad: </label>
            <input type="text" className="form-control" placeholder="" id="nacionalidad"
                name="nacionalidad" maxLength="20" value={datos.nacionalidad} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("nacionalidad")}</div>
            </div>
    </div>

    <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Estado Civil: </label>
            <select class="form-control" name="estcivil" value = {datos.estcivil} onChange={changeHandler} >
            {
                configSecc.estadocivil.map(sec=>{return <option value={sec.nombre}>{sec.nombre}</option>})
            }
            
        </select>
          
        </div>
        <div className="col-sm-4 form-group">
            <label className="control-label">CUIL Nº: </label>
            <input type="text" className="form-control" placeholder="" id="cuil"
                name="cuil" maxLength="13" value={datos.cuil} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("cuil")}</div>
            </div>
            <div className="col-sm-4 form-group">
            <label className="control-label">Celular: </label>
            <input type="text" className="form-control" placeholder="" id="cel"
                name="cel" maxLength="15" value={datos.cel} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("cel")}</div>
            </div>
          
    </div>

    <h3 className="bd-content-title">
            Datos laborales: (donde presta servicio)
        </h3>


    <div className="row">
        <div className="col-sm-6 form-group">
            <label className="control-label">CUIT Nº:</label>
            <input type="text" className="form-control" placeholder="" id="cuit"
                name="cuit" maxLength="12" value={datos.cuit} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("cuit")}</div>
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label">Fecha de alta:</label>
            <input type="date" className="form-control" placeholder="" id="fechaalta"
                name="fechaalta" value={datos.fechaalta} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("fechaalta")}</div>
        </div>
    </div>
    <div className="row">
        <div className="col-sm-6 form-group">
            <label className="control-label">Razón Social:</label>
            <input type="text" className="form-control" placeholder="" id="razonsocial"
                name="razonsocial" maxLength="30" value={datos.razonsocial} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("razonsocial")}</div>
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label">Categoría laboral:</label>
            <input type="text" className="form-control" placeholder="" id="categorialaboral"
                name="categorialaboral" maxLength="30" value={datos.categorialaboral} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("categorialaboral")}</div>
        </div>
    </div>
    <div className="row">
        <div className="col-sm-6 form-group">
            <label className="control-label">Direccion:</label>
            <input type="text" className="form-control" placeholder="" id="direccionlaboral"
                name="direccionlaboral" maxLength="30" value={datos.direccionlaboral} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("direccionlaboral")}</div>
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label">Localidad:</label>
            <input type="text" className="form-control" placeholder="" id="localidadlaboral"
                name="localidadlaboral" maxLength="30" value={datos.localidadlaboral} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("localidadlaboral")}</div>
        </div>
    </div>
    <div className="row">
        <div className="col-sm-6 form-group">
            <label className="control-label">Provincia:</label>
            <select class="form-control" name="provincialaboral" value = {datos.provincialaboral} onChange={changeHandler} >
            {
                configSecc.provincias.map(sec=>{return <option value={sec.nombre}>{sec.nombre}</option>})
            }
            </select>
            
        
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label">Telefono:</label>
            <input type="text" className="form-control" placeholder="" id="telefonolaboral"
                name="telefonolaboral" maxLength="30" value={datos.telefonolaboral} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("telefonolaboral")}</div>
        </div>
    </div>

    <div className="row">
        <div className="col-sm-6 form-group">
            <label className="control-label">Email:</label>
            <input type="text" className="form-control" placeholder="" id="emaillaboral"
                name="emaillaboral" maxLength="30"value= {datos.emaillaboral} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("emaillaboral")}</div>
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label">Página Web:</label>
            <input type="text" className="form-control" placeholder="" id="paginaweblaboral"
                name="paginaweblaboral" maxLength="30" value={datos.paginaweblaboral} onChange={changeHandler}/>
                <div className="formError">{getErrorMessageField("paginaweblaboral")}</div>
        </div>
    </div>

    <h3>
            Declaración jurada familiares a cargo:
        </h3>
<div className="row">
    <div className="col-sm-12-form-group">
        Familiar 1
    </div>
</div>

    <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Apellido y nombre:</label>
            <input type="text" className="form-control" placeholder="" id="f1apellidonombre"
                name="f1apellidonombre" maxLength="30" value={datos.f1apellidonombre} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Parentesco:</label>
            <input type="text" className="form-control" placeholder="" id="f1parentesco"
                name="f1parentesco" maxLength="15"  value={datos.f1parentesco} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">DNI:</label>
            <input type="text" className="form-control" placeholder="" id="f1cuil"
                name="f1cuil" maxLength="13"  value={datos.f1cuil} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Fec Nac:</label>
            <input type="date" className="form-control" placeholder="" id="f1fecnac"
                name="f1fecnac"  value={datos.f1fecnac} onChange={changeHandler}/>
        </div>
    </div>

    <div className="row">
    <div className="col-sm-12-form-group">
        Familiar 2
    </div>
</div>

    <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Apellido y nombre:</label>
            <input type="text" className="form-control" placeholder="" id="f2apellidonombre"
                name="f2apellidonombre" maxLength="30" value={datos.f2apellidonombre} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Parentesco:</label>
            <input type="text" className="form-control" placeholder="" id="f2parentesco"
                name="f2parentesco" maxLength="15" value={datos.f2parentesco} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">CUIL:</label>
            <input type="text" className="form-control" placeholder="" id="f2cuil"
                name="f2cuil" maxLength="13" value={datos.f2cuil} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Fec Nac:</label>
            <input type="date" className="form-control" placeholder="" id="f2fecnac"
                name="f2fecnac" value={datos.f2fecnac} onChange={changeHandler} />
        </div>
    </div>
    <div className="row">
    <div className="col-sm-12-form-group">
        Familiar 3
    </div>
</div>

    <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Apellido y nombre:</label>
            <input type="text" className="form-control" placeholder="" id="f3apellidonombre"
                name="f3apellidonombre" maxLength="30"  value={datos.f3apellidonombre} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Parentesco:</label>
            <input type="text" className="form-control" placeholder="" id="f3parentesco"
                name="f3parentesco" maxLength="15" value={datos.f3parentesco} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">CUIL:</label>
            <input type="text" className="form-control" placeholder="" id="f3cuil"
                name="f3cuil" maxLength="13" value={datos.f3cuil} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Fec Nac:</label>
            <input type="date" className="form-control" placeholder="" id="f3fecnac"
                name="f3fecnac" value={datos.f3fecnac} onChange={changeHandler}/>
        </div>
    </div>

    <div className="row">
    <div className="col-sm-12-form-group">
        Familiar 4
    </div>
</div>
    <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Apellido y nombre:</label>
            <input type="text" className="form-control" placeholder="" id="f4apellidonombre"
                name="f4apellidonombre" maxLength="30"  value={datos.f4apellidonombre} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Parentesco:</label>
            <input type="text" className="form-control" placeholder="" id="f4parentesco"
                name="f4parentesco" maxLength="15" value={datos.f4parentesco} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">CUIL:</label>
            <input type="text" className="form-control" placeholder="" id="f4cuil"
                name="f4cuil" maxLength="13" value={datos.f4cuil} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Fec Nac:</label>
            <input type="date" className="form-control" placeholder="" id="f4fecnac"
                name="f4fecnac" value={datos.f4fecnac} onChange={changeHandler}/>
        </div>
    </div>
    <div className="row">
    <div className="col-sm-12-form-group">
        Familiar 5
    </div>
</div>

    <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Apellido y nombre:</label>
            <input type="text" className="form-control" placeholder="" id="f5apellidonombre"
                name="f5apellidonombre" maxLength="30"  value={datos.f5apellidonombre} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Parentesco:</label>
            <input type="text" className="form-control" placeholder="" id="f4parentesco"
                name="f5parentesco" maxLength="15" value={datos.f5parentesco} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">CUIL:</label>
            <input type="text" className="form-control" placeholder="" id="f5cuil"
                name="f5cuil" maxLength="13" value={datos.f5cuil} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Fec Nac:</label>
            <input type="date" className="form-control" placeholder="" id="f5fecnac"
                name="f5fecnac" value={datos.f5fecnac} onChange={changeHandler}/>
        </div>
    </div>

    <div className="row">
        <div className="col-sm-12 form-group">
            <label className="control-label">Observaciones:</label>
            <input type="text" className="form-control" placeholder="" id="observaciones"
                name="observaciones" maxLength="30" value={datos.observaciones} onChange={changeHandler}/>
        </div>
    </div>

    <h3>
            Documentación:
        </h3>


    <div className="row">
        <div className="col-sm-3 form-group">
            <label className="control-label">Foto último recibo de sueldo:</label>
            <input type="file"  accept={fileAccept}  className="form-control" placeholder="" id="recibosueldo"
                name="recibosueldo" maxLength="30" value={datos.recibosueldo} onChange={handleFileUploadRecibo}/>
                                <div className="formError">{getErrorMessageField("fileRecibo")}
                                {getErrorMessageFieldSize("fileReciboSize")}</div>

        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Foto alta temprana AFIP:</label>
            <input type="file"  accept={fileAccept}  className="form-control" placeholder="" id="altatemprana"
                name="altatemprana" maxLength="30" value={datos.altatemprana} onChange={handleFileUploadAlta}/>
                                <div className="formError">{getErrorMessageField("fileAlta")}
                                {getErrorMessageFieldSize("fileAltaSize")}</div>

        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Foto DNI frente:</label>
            <input type="file"  accept={fileAccept} className="form-control" placeholder="" id="fotodni"
                name="fotodni" maxLength="30" onChange={handleFileUploadDNI1} value={datos.fotodni}/>
                                <div className="formError">{getErrorMessageField("fileDNI")}
                                {getErrorMessageFieldSize("fileDNISize")}</div>

        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Foto DNI dorso:</label>
            <input type="file"    accept={fileAccept} className="form-control" placeholder="" id="fotodni2"
                name="fotodni2" maxLength="30" onChange={handleFileUploadDNI2} value={datos.fotodni2}/>
                                <div className="formError">{getErrorMessageField("fileDNI2")}
                                {getErrorMessageFieldSize("fileDNI2Size")}</div>

        </div>
    </div>




   
    <div className="row">
        <div className="col formTitle1">
        { (tipoForm=="OS" || tipoForm == "OSSIN")?
           <> {(firmaStringOS=="" || firmaStringOS==undefined)?
           <input type="button" className="btn btn-primary btnEnviar" value ="Firmar Obra Social" onClick={toggleModalFirmaOS}/>:
           <span className="letraChica"><img  className="imagenConfirm" src="./confirm.png"/>FIRMADO OBRA SOCIAL</span>}

         
        <div className="formError">{getErrorFirmaMessageField("firmaOS")}</div>
            </> : <span>&nbsp;</span>}
            </div>
    </div>

       
    <div className="row">
        <div className="col formTitle1">
        { (tipoForm=="SIN" || tipoForm == "OSSIN")?
           <>{(firmaStringSIN=="" || firmaStringSIN==undefined)?
           <input type="button" className="btn btn-primary btnEnviar "  value ="Firmar Sindicato" onClick={toggleModalFirmaSIN}/>
           :
          <span className="letraChica"><img  className="imagenConfirm" src="./confirm.png"/> FIRMADO SINDICATO</span>  }
          
            <div className="formError">{getErrorFirmaMessageField("firmaSIN")}</div>
            </> : <span>&nbsp;</span>}            
            </div>
    </div>

   
    <div className="row">
        <div className="col formTitle1">
            <input type="submit" className="btn btn-primary btnEnviar" style={{backgroundColor:"green"}} value="Enviar registración" onClick={handleSubmit} disabled={loading}/> </div>
    </div>
    <div className="col-12 alignCenter topTo10 ">
            {loading?<Spinner color="info"/>:""}
            </div>


    
</div>


    </>);
}

export default FormularioOS1;
